import gql from 'graphql-tag';
import userInfoFragment from '../user/userInfo';

export default gql`
  fragment threadParticipant on ThreadParticipant {
    user {
      ...userInfo
    }
    isMember
    isModerator
    isBlocked
    isOwner
    roles
    reputation
  }
  ${userInfoFragment}
`;
